<main class="app-grid" *ngIf="!loading && playlist.length > 0">
  <section>
    <div #playerContainer class="player">
      <div class="title-box">
      <h2 class="title">{{ playlist[currentIndex]?.title || "Video" }}</h2>
    </div>
      <video
        #videoPlayer
        class="video"
        crossorigin="anonymous"
        autoplay
        muted
        playsinline
        preload="auto"
        (click)="onTogglePlayPause()"
        (play)="onPlay()"
        (pause)="onPause()"
        (timeupdate)="onTimeUpdate()"
        (loadedmetadata)="onLoadedMetadata()"
        (canplay)="onCanPlay()"
        (ended)="onEnded()"
        (error)="onError()"
      ></video>

      <div class="controls">
        <div #progressContainer class="progress" aria-label="Seek">
          <div class="progress-track" (click)="onSeek($event)">
            <div
              class="progress-watched"
              [style.width.%]="watchedPercent"
            ></div>
            <div class="progress-fill" [style.width.%]="progressPercent"></div>
          </div>
        </div>

        <div class="bottom-bar">
          <div class="left">
            <div class="play-group">
              <!-- rewind 10s -->
              <button
                mat-icon-button
                color="primary"
                aria-label="Rewind 10 seconds"
                (click)="stepBack(10)"
              >
                <mat-icon class="play-pause-icon">replay_10</mat-icon>
              </button>

              <!-- play/pause -->
              <button
                mat-icon-button
                color="primary"
                (click)="onTogglePlayPause()"
                aria-label="Play/Pause"
              >
                <mat-icon class="play-pause-icon" *ngIf="isPaused"
                  >play_arrow</mat-icon
                >
                <mat-icon class="play-pause-icon" *ngIf="!isPaused"
                  >pause</mat-icon
                >
              </button>

              <!-- forward 10s (enabled only after a backward) -->
              <button
                mat-icon-button
                color="primary"
                aria-label="Forward 10 seconds"
                (click)="stepForward(10)"
                [disabled]="!canForward"
                class="forward-btn"
              >
                <mat-icon class="play-pause-icon">forward_10</mat-icon>
              </button>
            </div>

            <div class="time">
              <span class="mono">{{ formatTime(currentTime) }}</span>
              <span class="dim"> / </span>
              <span class="mono">{{ formatTime(duration) }}</span>
            </div>
          </div>

          <div class="right">
            <button
              mat-icon-button
              color="primary"
              (click)="onFullScreenToggle()"
              aria-label="Fullscreen"
            >
              <mat-icon class="fullscreen-icon">fullscreen</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section>
    <mat-card class="playlist-card">
      <mat-card-header>
        <mat-card-title>Your Playlist</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="totals mono" role="group" aria-label="Playlist totals">
          <div class="totals-box">
            <p class="hdr">ELAPSED</p>
            <p class="value">{{ formatTime(totalElapsed) }}</p>
          </div>
          <div class="totals-box">
            <p class="hdr">REMAINING</p>
            <p class="value">{{ formatTime(totalRemaining) }}</p>
          </div>
          <div class="totals-box">
            <p class="hdr">TOTAL</p>
            <p class="value">{{ formatTime(totalPlaylistDuration) }}</p>
          </div>
        </div>

        <mat-divider></mat-divider>

        <h4 class="video-count">
          {{ currentIndex + 1 }} / {{ playlist.length }}
        </h4>

        <div class="list-scroll" #playlistScroll>
          <mat-nav-list>
            <a
              mat-list-item
              *ngFor="let v of playlist; let i = index"
              (click)="onPickFromPlaylist(i)"
              [class.active]="i === currentIndex"
              [class.disabled]="i > maxReachedIndex"
              [class.watched]="v.watched"
              [attr.aria-current]="i === currentIndex ? 'true' : null"
              #playlistItem
            >
              <div matListItemTitle class="row">
                <span class="index mono">{{ i + 1 | number : "2.0" }}</span>

                <!-- Always render icon placeholder -->
                <span
                  class="icon"
                  [innerHTML]="v.icon ? safeSvg(v.icon) : ''"
                ></span>

                <span class="name">{{ v.title }}</span>
                <span class="dur mono">{{ formatTime(v.duration || 0) }}</span>
                <mat-icon
                  class="playing"
                  *ngIf="i === currentIndex && !isPaused"
                >
                  play_circle_filled
                </mat-icon>
              </div>
            </a>
          </mat-nav-list>
        </div>
      </mat-card-content>
    </mat-card>
  </section>
</main>
